import {
    LOGIN, LOGOUT
} from '../actions/Types';
import { setTokens, getUser, getIsAuthenticated } from '../Helpers/LocalStorage';


const initialState = {
    client_User: JSON.parse(getUser()) || null,
    isLoggedIn: getIsAuthenticated || false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case LOGIN:
            setTokens(action.payload);
            return {
                ...state,
                client_User: action.payload,
                isLoggedIn: true,
            };
        case LOGOUT:
            localStorage.clear();
            return {
                ...state,
                user: null,
            };
        default:
            return state;
    }
}
